module.exports = __webpack_public_path__ + "static/media/HeaderHome.6ec51067.png";